import { ref } from 'vue';
import { toast } from 'vue-sonner';
import * as LectureCompletionApi from '@/api/agent/university/lecture_completion';

type CompletableLecture = { id: number; completed: boolean };

export const useLectureCompletion = () => {
  const pending = ref(false);

  const setCompletion = async (lecture: CompletableLecture, completed: boolean) => {
    if (lecture.completed === completed) return;

    const previous = lecture.completed;
    lecture.completed = completed;
    pending.value = true;

    const response = completed
      ? await LectureCompletionApi.createLectureCompletion(lecture.id)
      : await LectureCompletionApi.deleteLectureCompletion(lecture.id);

    pending.value = false;

    if (response.status === 'error') {
      lecture.completed = previous;
      toast.error('Could not update your progress. Please try again.');
    }
  };

  const toggle = (lecture: CompletableLecture) => setCompletion(lecture, !lecture.completed);
  const markComplete = (lecture: CompletableLecture) => setCompletion(lecture, true);

  return { pending, setCompletion, toggle, markComplete };
};
